export { getUrlPathname };
import { parseUrl } from './parseUrl';
function getUrlPathname(url) {
    const urlPathname = parseUrl(url, '/').pathname;
    return urlPathname;
}
